import { fleetApiHttp } from '@/services/api/tattle-http'
import type { AttentionAnswer, TeamDecisionsAnswer, TeamFeedCard, TeamList, TeamReadyAnswer } from './claude-team.types'

type FeedList = Exclude<TeamList, 'decisions'>

export const ClaudeTeamApi = {
  async getDecisions() {
    const response = await fleetApiHttp.get<TeamDecisionsAnswer>('/team/decisions')
    return response.data
  },

  /** The fleet names the array after the list (`approved`, `merged`, `cancelled`). */
  async getFeed(list: FeedList) {
    const response = await fleetApiHttp.get<{ asOf: string; days: number | null } & Partial<Record<FeedList, TeamFeedCard[]>>>(
      `/team/${list}`
    )
    return response.data
  },

  async getReady() {
    const response = await fleetApiHttp.get<TeamReadyAnswer>('/team/ready')
    return response.data
  },

  async getAttention() {
    const response = await fleetApiHttp.get<AttentionAnswer>('/team/attention')
    return response.data
  }
}
